import React from 'react';
import { Box, List } from '@mui/material';

import RewardItem from './RewardItem'

const Rewards = ({ rewards, userScore, setScore }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <List>
        {rewards.map((reward, index) => (
          <RewardItem
            key={index}
            id={reward.id}
            image={reward.image}
            name={reward.name}
            score={reward.score}
            setScore={setScore}
            canUnlock={userScore >= reward.score}
          />
        ))}
      </List>
    </Box>
  );
};

export default Rewards;
